const key = "add-contains-engine";

const applicable = (resp) => {
	return resp.config.url.match(/api\/forms\/176$/);
};

const CONTAINS_FIELD_SCOPES = [
	// { keyCode: "TRIP.AREAS.LATITUDE.SINGLE", scope: "COORD_Y" },
	// { keyCode: "TRIP.AREAS.LONGITUDE.SINGLE", scope: "COORD_X" },
	{ keyCode: "TRIP.EFFORT.CATCH.LOCATION", scope: "COORD_XY" },
	{ keyCode: "TRIP.AREAS.SINGLE", scope: "EVALUATIONSET" }
];

const findFieldIdByKey = (fields, keyCode) => fields.find(f => f.Key?.Code === keyCode)?.Id;

const buildContainsConditions = (fields) => CONTAINS_FIELD_SCOPES.reduce((conditions, fieldScope, index) => {
	const fieldId = findFieldIdByKey(fields, fieldScope.keyCode);
	if(fieldId === undefined) {
		return conditions;
	}

	conditions.push({
		Id: index + 1,
		Field: {
			Id: fieldId
		},
		Scope: {
			Code: fieldScope.scope
		}
	});

	return conditions;
}, [{
	Id: 1000,
	Scope: { Code: "TYPE" },
	Value: "GEOJSON"
}]);

const ruleJson = (conditions) => ({
	"Id": 176001,
	"Title": "The selected location is not inside of the selected location block.",
	"Code": "TRIP.EFFORT.CATCH.LOCATION.OUTSIDE.AREA",
	"Operator":
	{
		"Id": 1,
		"Code": "AND",
		"Name": "And"
	},
	"Engine":
	{
		"Id": 1,
		"Code": "CONTAINS",
		"Name": "Contains"
	},
	"Conditions": conditions,
	"Triggers":
	[
		{
			"Operator":
			{
				"Id": 1,
				"Code": "BLOCKSAVE",
				"Name": "Block Saving"
			},
			"Type":
			{
				"Id": 1,
				"Code": "VALIDATION",
				"Name": "Validation"
			}
		}
	]
});

const modify = (resp) => {
	if(!resp.data.Data?.Rules || !resp.data.Data?.Fields) {
		return;
	}

	const conditions = buildContainsConditions(resp.data.Data.Fields);

	resp.data.Data.Rules.push(ruleJson(conditions));
};

export const addContainsEngine = [key, applicable, modify];
